import React, { useState, useEffect } from 'react';
import { Modal, Select, Input, Form, Button } from 'antd';
import style from './index.scss';
import PropTypes from 'prop-types';

const AddRuleModal = ({
  addRuleVisible,
  onCancel,
  isLoading,
  tableData,
  setTableData,
  riskIndicatorsState,
  setRiskIndicatorData
}) => {
  // const [select1Value, setSelect1Value] = useState('');
  // const [select2Value, setSelect2Value] = useState('');
  // const [inputValue, setInputValue] = useState('');
  const [form] = Form.useForm();
  const [formValid, setFormValid] = useState(true);
  const [riskIndicator, setRiskIndicator] = useState('');
  const [inputPattern, setInputPattern] = useState(/^[a-zA-Z0-9., ]+$/);
  const [patternLabel, setPatternLabel] = useState('alphanumeric');

  const handleRiskIndicatorChange = (value) => {
    setRiskIndicator(value);
    form.setFieldsValue({
      condition: '',
      value: ''
    });
  };

  const getRiskIndicatorOptions = (riskIndicatorsState, tableData) => {
    if (Array.isArray(riskIndicatorsState)) {
      // const mapTableData = tableData.map(data => {

      //  const filterExistingIndicators = riskIndicatorsState.filter(indicator => !(indicator.displayName === data.displayName))
      //  return filterExistingIndicators
      // })

      const filteredIndicators = riskIndicatorsState.filter(
        (indicator) =>
          !tableData.some((data) => data.displayName === indicator.displayName)
      );
      const riskIndicatorOptions = filteredIndicators.map((indicator) => (
        <Select.Option key={indicator.name} value={indicator.displayName}>
          {indicator.displayName}
        </Select.Option>
      ));
      return riskIndicatorOptions;
    } else return [];
  };

  const FORM_INITIAL_VALUES = {
    riskIndicator: '',
    condition: '',
    value: ''
  };

  const updateButtonStatus = () => {
    setFormValid(
      form.getFieldValue('riskIndicator') === '' ||
        form.getFieldValue('condition') === '' ||
        form.getFieldValue('value') === '' ||
        form.getFieldError('value').length > 0
    );
  };

  const handleAddRuleCancel = () => {
    form.resetFields();
    setRiskIndicator('');
    setFormValid(true);
  };

  const handleAddRuleConfirm = (values, tableData, riskIndicatorsState) => {
    const findIndicatorData = riskIndicatorsState.find(
      (data) => data.displayName === values.riskIndicator
    );
    // setTableData([
    //   ...tableData,
    //   {
    //     displayName: findIndicatorData.displayName,
    //     name: findIndicatorData.name,
    //     // selectedCondition: values.condition,
    //     // values: values.value,
    //     weight: ''
    //   }
    // ]);

    setRiskIndicatorData([
      ...tableData,
      {
        displayName: findIndicatorData.displayName,
        name: findIndicatorData.name,
        // selectedCondition: values.condition,
        // values: values.value,
        weight: ''
      }
    ]);
  };

  // regex by MARCUS
  // const getInputPattern = (value) => {
  //     const selectedRiskIndicator = (riskIndicatorsState || []).find(
  //         (indicator) => indicator.riskIndicator == value
  //     );

  //     switch (selectedRiskIndicator?.riskIndicatorType) {
  //         case 'Boolean':
  //             setInputPattern(/^([Tt][Rr][Uu][Ee]|[Ff][Aa][Ll][Ss][Ee])$/);
  //             setPatternLabel('boolean');
  //             break;
  //         case 'Numeric':
  //             setInputPattern(/^\d{0,9}(\.\d{0,6})?$/);
  //             setPatternLabel('numberic');
  //             break;
  //         case 'String':
  //             setInputPattern(/^[a-zA-Z0-9, ]+$/);
  //             setPatternLabel('alphanumeric');
  //             break;
  //         default:
  //             setInputPattern(/^[a-zA-Z0-9., ]+$/);
  //             setPatternLabel('alphanumeric');
  //     }
  // };

  const addRI = (status) => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        handleAddRuleConfirm(values, tableData, riskIndicatorsState);
        if (status) onCancel(false);
      })
      .catch((info) => {});
  };

  useEffect(() => {
    form.resetFields();
  }, [addRuleVisible]);

  return (
    <Modal
      visible={addRuleVisible}
      title="Add Rule"
      className={style.addRuleModal}
      onCancel={() => onCancel(false)}
      footer={
        <>
          <Button onClick={() => onCancel(false)}>Cancel</Button>
          <Button type="primary" onClick={() => addRI()}>
            Add
          </Button>
          <Button type="primary" onClick={() => addRI(true)}>
            Add & Close
          </Button>
        </>
      }>
      <Form
        size="small"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 17 }}
        form={form}
        onFieldsChange={updateButtonStatus}
        initialValues={FORM_INITIAL_VALUES}>
        <Form.Item
          label="Risk Indicator"
          name="riskIndicator"
          rules={[{ required: true, message: 'Risk indicator is required' }]}>
          <Select onChange={handleRiskIndicatorChange} loading={isLoading}>
            {getRiskIndicatorOptions(riskIndicatorsState, tableData)}
          </Select>
        </Form.Item>
        {/* <Form.Item
                    label="Condition"
                    name="condition"
                    rules={[{ required: true, message: 'Condition is required' }]}>
                    <Select onChange={handleRiskConditionChange}>
                        {getConditionOptions(riskIndicatorsState, riskIndicator)}
                    </Select>
                </Form.Item> */}
        {/* <Form.Item
                    label="Value"
                    name="value"
                    rules={[
                        { required: true, message: 'Value is required' },
                        {
                            pattern: inputPattern,
                            message: `This field can only contain ${patternLabel} values. Please enter valid information.`
                        }
                    ]}>
                    <Input />
                </Form.Item> */}
      </Form>
    </Modal>
  );
};

AddRuleModal.propTypes = {
  addRuleVisible: PropTypes.bool,
  onCancel: PropTypes.func,
  isLoading: PropTypes.bool,
  tableData: PropTypes.array,
  setTableData: PropTypes.func,
  riskIndicatorsState: PropTypes.array,
  setRiskIndicatorData: PropTypes.func
};

export default AddRuleModal;
